import { render, staticRenderFns } from "./Grade.vue?vue&type=template&id=dacd03bc&scoped=true&"
import script from "./Grade.vue?vue&type=script&lang=js&"
export * from "./Grade.vue?vue&type=script&lang=js&"
import style0 from "./Grade.vue?vue&type=style&index=0&id=dacd03bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dacd03bc",
  null
  
)

export default component.exports